import { Controller } from "stimulus";
import Swal from "sweetalert2";
export default class extends Controller {
  show_adjudication_options(event) {
    const element = event.target;
    this.show_base_on_logic(element);
  }

  showAlert() {
    Swal.fire({
      icon: "success",
      title: "Updated!",
      showConfirmButton: false,
      timer: 1500,
    });
  }

  show_base_on_logic(element) {
    const index = element.dataset.index;
    const isRequired = element.value === "Required";

    [
      ".logic_base_on_" + index,
      ".compare_to_" + index,
      ".operator_" + index,
      ".custom_value_" + index,
      ".transition_matrix_" + index,
    ].forEach((selector) => {
      const field = document.querySelector(selector);
      if (!field) return;
      isRequired
        ? field.classList.remove("hidden")
        : field.classList.add("hidden");
    });

    if (isRequired) {
      const baseOnSelect = document.querySelector(
        ".logic_base_on_" + index + " select",
      );
      if (baseOnSelect) {
        this.show_operate_value_fields(baseOnSelect);
      }
    }
  }

  show_operater_value(event) {
    const element = event.target;
    this.show_operate_value_fields(element);
  }

  show_operate_value_fields(element) {
    let operater_option = document.querySelector(
      ".operator_" + element.dataset.index,
    );
    let value_option = document.querySelector(
      ".custom_value_" + element.dataset.index,
    );
    const operatorSelect = operater_option
      ? operater_option.querySelector("select")
      : null;

    const setOperatorOptions = (selectElem, mode) => {
      if (!selectElem) return;
      const current = selectElem.value;
      let options = [];
      if (mode === "absolute_difference") {
        options = [
          { label: "Greater Than", value: ">" },
          { label: "Greater OR Equal", value: ">=" },
          { label: "Less Than", value: "<" },
          { label: "Less OR Equal", value: "<=" },
        ];
      } else if (mode === "Percentage") {
        options = [
          { label: "Greater Than", value: ">" },
          { label: "Less Than", value: "<" },
        ];
      } else {
        options = [
          { label: "Equal", value: "=" },
          { label: "Greater OR Equal", value: ">=" },
          { label: "Less OR Equal", value: "<=" },
          { label: "Greater Than", value: ">" },
          { label: "Less Than", value: "<" },
        ];
      }

      selectElem.innerHTML = options
        .map((o) => `<option value="${o.value}">${o.label}</option>`)
        .join("");

      const allowedValues = options.map((o) => o.value);
      selectElem.value = allowedValues.includes(current)
        ? current
        : options[0].value;
    };
    const isThresholdRule =
      element.value === "Custom" ||
      element.value === "Percentage" ||
      element.value === "absolute_difference";
    const isNotLessThanPrevious = element.value === "not_less_than_previous";
    const showThresholdColumn =
      isThresholdRule ||
      element.value === "Transition Rules" ||
      isNotLessThanPrevious;

    isThresholdRule
      ? operater_option.classList.remove("hidden")
      : operater_option.classList.add("hidden");
    setOperatorOptions(operatorSelect, element.value);

    showThresholdColumn
      ? value_option.classList.remove("hidden")
      : value_option.classList.add("hidden");

    if (value_option) {
      const hint = value_option.querySelector(".not-less-than-hint");
      const thresholdInput = value_option.querySelector(".threshold-input");
      if (hint) hint.classList.toggle("hidden", !isNotLessThanPrevious);
      if (thresholdInput)
        thresholdInput.classList.toggle("hidden", isNotLessThanPrevious);
    }
  }
}
